import React from 'react';
import { Link } from 'react-router-dom';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

function AnswerList() {
  const { answer, title, description } = style;

  return (
    <>
      <SectionHeader
        headingLeft='Profile'
        headingRight='Most Recent / All-Time Views'
        colWith={4}
      />
      <div className='row row--main-content'>
        {[1, 2, 3, 4, 5].map(profAnswer => (
          <div className={`col-12 ${answer}`} key={profAnswer}>
            <h3 className={title}>
              <Link to='/answer/id' className={style['title-link']}>
                What are your post match thoughts on the lightweight boxing
                match between Jorge Linares and Vasyl Lomachenko in Madision
                Square Garden in 2018 as well as the prospects of a rematch?
              </Link>
            </h3>
            <div className={`row ${style['row--user']}`}>
              <div className={`col-1 ${style['col--image']}`}>
                <img
                  className={style['profile-img']}
                  src='https://i.imgur.com/qHpJwKV.jpg'
                  alt='User Avatar'
                />
              </div>
              <div className={`col-11 ${style['col--info']}`}>
                <p className={style['profile-user-info']}>
                  <Link
                    to='/account/profile'
                    className={style['profile-user-link']}
                  >
                    Collins A. Orlando
                  </Link>
                  , Sweet 'Scientist'.
                </p>
                <p className='text-muted'>Answered May 13</p>
              </div>
              <div className={`col-12 ${style['col--desc']}`}>
                <p className={description}>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Earum aliquam quisquam quis, culpa maxime perferendis sint,
                  accusantium illo deleniti sunt ipsa. Culpa id officiis
                  accusamus.
                  <span className={style['description-more']}> (more)</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default AnswerList;
